// Configuration for API endpoints and Socket.IO connections
// Priority: 1) REACT_APP_* env vars (Vercel), 2) NODE_ENV production (Railway), 3) localhost (dev)

const getApiBaseUrl = () => {
  // 1. Check for explicit environment variable (set in Vercel)
  if (process.env.REACT_APP_API_URL) {
    const url = process.env.REACT_APP_API_URL;
    console.log('🔍 [CONFIG] API_BASE_URL (from REACT_APP_API_URL):', url);
    return url;
  }
  
  // 2. If in production mode, use Railway URL
  if (process.env.NODE_ENV === 'production') {
    const url = 'https://mech-basketball-league-production.up.railway.app/api';
    console.log('🔍 [CONFIG] API_BASE_URL (production, Railway):', url);
    return url;
  }
  
  // 3. Development: use localhost
  const url = 'http://localhost:3001/api';
  console.log('🔍 [CONFIG] API_BASE_URL (development, localhost):', url);
  return url;
};

const getSocketUrl = () => {
  // 1. Check for explicit environment variable (set in Vercel)
  if (process.env.REACT_APP_SOCKET_URL) {
    const url = process.env.REACT_APP_SOCKET_URL;
    console.log('🔍 [CONFIG] SOCKET_URL (from REACT_APP_SOCKET_URL):', url);
    return url;
  }
  
  // 2. If in production mode, use Railway URL
  if (process.env.NODE_ENV === 'production') {
    const url = 'https://mech-basketball-league-production.up.railway.app';
    console.log('🔍 [CONFIG] SOCKET_URL (production, Railway):', url);
    return url;
  }
  
  // 3. Development: use localhost
  const url = 'http://localhost:3001';
  console.log('🔍 [CONFIG] SOCKET_URL (development, localhost):', url);
  return url;
};

export const API_BASE_URL = getApiBaseUrl();
export const SOCKET_URL = getSocketUrl();

// Debug: Log the actual URLs being used
console.log('🔍 [CONFIG] API_BASE_URL:', API_BASE_URL);
console.log('🔍 [CONFIG] SOCKET_URL:', SOCKET_URL);
console.log('🔍 [CONFIG] NODE_ENV:', process.env.NODE_ENV);

// Game duration in milliseconds
export const GAME_DURATION_MS = 900000; // 15 minutes (15 * 60 * 1000)

